import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";
import type { Dish } from "@/mocks/dishes";

type DishCardProps = {
  dish: Dish;
  index: number;
};

export default function DishCard({ dish, index }: DishCardProps) {
  const { t } = useTranslation();

  return (
    <Reveal delay={(index % 3) * 90} className="h-full">
      <article className="flex h-full flex-col">
        <div className="aspect-[4/3] w-full overflow-hidden rounded-lg bg-background-200">
          <img
            src={dish.image}
            alt={t(`dishes.${dish.id}.alt`)}
            loading="lazy"
            className="h-full w-full object-cover"
          />
        </div>
        <span className="mt-5 font-body text-[11px] uppercase tracking-[0.28em] text-accent-500">
          {t(`dishes.${dish.id}.tag`)}
        </span>
        <h3 className="mt-2 font-heading text-2xl leading-tight text-foreground-50 md:text-[28px]">
          {t(`dishes.${dish.id}.name`)}
        </h3>
        <p className="mt-3 font-body text-base leading-relaxed text-secondary-500">
          {t(`dishes.${dish.id}.description`)}
        </p>
      </article>
    </Reveal>
  );
}